import $ from 'jquery';
import Push from 'push.js';

Push.config({ serviceWorker: '/dist/serviceWorker.min.js' });

var localStorage = window.localStorage; // for eslint

const connectFilterNotifications = {
  emailNotificationsOn: function () {
    return !!$('.js-notifications-bell').length;
  },

  isOn: function () {
    return !!(
      localStorage.getItem(this.keys.filters) && this.notificationData()
    );
  },

  getEmployeeIds: function () {
    return this._find_filter('employee_ids');
  },

  getTextSearch: function () {
    return this._find_filter('search');
  },

  getFilterParams: function () {
    return JSON.parse(localStorage.getItem(this.keys.filters));
  },

  getCheckboxes: function () {
    return JSON.parse(localStorage.getItem(this.keys.checkboxes)) || [];
  },

  getMostRecent: function () {
    return localStorage.getItem(this.keys.mostRecent);
  },

  setFilters: function ($form, onGranted, onDenied) {
    var keys = this.keys;

    var afterSet = function () {
      var checkboxes = $form
        .find(':checkbox:checked')
        .map(function () {
          return this.id;
        })
        .toArray();
      localStorage.setItem(keys.checkboxes, JSON.stringify(checkboxes));
      localStorage.setItem(
        keys.filters,
        JSON.stringify($form.serializeArray()),
      );
      onGranted && onGranted();
    };

    if (this.isIE()) {
      afterSet();
    } else {
      Push.Permission.request(afterSet, onDenied);
    }
  },

  setMostRecent: function (val) {
    localStorage.setItem(this.keys.mostRecent, val);
  },

  setStreamFilters: function () {
    $('.js-filter-form :checkbox').prop('checked', false);
    this.getCheckboxes().forEach(function (id) {
      $('#' + id).prop('checked', true);
    });
    $('.js-filter-form #search').val(
      connectFilterNotifications.getTextSearch(),
    );
    $('#employee_ids').val(connectFilterNotifications.getEmployeeIds());
  },

  clear: function () {
    var keys = this.keys;
    Object.keys(keys).forEach(function (key) {
      localStorage.removeItem(keys[key]);
    });
  },

  isIE: function () {
    // http://stackoverflow.com/questions/24861073/detect-if-any-kind-of-ie-msie
    var navigator = window.navigator;
    return (
      navigator.appName == 'Microsoft Internet Explorer' ||
      !!(
        navigator.userAgent.match(/Trident/) ||
        navigator.userAgent.match(/rv:11/)
      ) ||
      (typeof $.browser !== 'undefined' && $.browser.msie == 1)
    );
  },

  sendAlert: function () {
    this.isIE() ? this._ieAlert() : this._pushAlert();
  },

  notificationData: function () {
    return $('#js-alert-filer-data').data();
  },

  _find_filter: function (name) {
    var filters = this.getFilterParams();
    if (!filters) {
      return '';
    }
    var object = filters.find(function (e) {
      return e.name == name;
    });
    return object ? object.value : '';
  },

  _pushAlert: function () {
    var that = this;
    var notificationData = this.notificationData();
    if (!notificationData) {
      return false;
    }
    var options = {
      body: notificationData.body,
      icon: notificationData.icon,
      onClick: function () {
        this.close();
        var myWindow = window.open(notificationData.redirectUrl);
        myWindow.focus();
        that.notified = false;
      },
    };
    Push.create(notificationData.header, options);
  },

  _ieAlert: function () {
    window.alert(this.notificationData().header);
  },

  keys: {
    mostRecent: 'feedbackNotificationMostRecent',
    filters: 'feedbackNotificationFilters',
    checkboxes: 'feedbackNotificationCheckboxes',
  },
};

export default connectFilterNotifications;
